import {
  Dialog as MuiDialog,
  DialogContent,
  Box,
  DialogActions,
  Button,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { DateTab, TimeTab } from "./TabPanel";
import { Toolbar } from "./Toolbar";

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (date: any) => void;
  defaultValue: Date;
  cancelLabel: string;
  okLabel: string;
};

export const Dialog = ({ defaultValue, open, onClose, onSubmit, cancelLabel, okLabel }: Props) => {
  const [date, setDate] = useState(defaultValue);
  useEffect(() => {
    setDate(defaultValue)
  }, [defaultValue])
  const [calendarType, setCalendarType] = useState<"date" | "year">("date");
  const [type, setType] = useState<"hours" | "minutes" | "seconds">("hours");
  const [currentTab, setCurrentTab] = useState(1);
  const baseProps = {
    date: date,
    setDate: setDate,
    currentTab: currentTab,
  };
  return (
    <MuiDialog  open={open} onClose={onClose}>
      <DialogContent
        style={{
          padding: 0,
          minWidth: 325,
        }}
      >
        <Box>
          <Toolbar
            {...baseProps}
            setCurrentTab={setCurrentTab}
            setCalendarType={setCalendarType}
            setType={setType}
          />
          <DateTab
            {...baseProps}
            calendarType={calendarType}
            setCalendarType={setCalendarType}
            setDate={setDate}
            currentTab={currentTab}
          />
          <TimeTab {...baseProps} setType={setType} type={type} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button color="primary" onClick={() => onSubmit(date)}>
          {okLabel}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
